/**
 * EmptyState illustrations — minimal SVG, no extra deps.
 * Three variants tied to the Baobab/Terracotta/Sand palette.
 */
export function EmptyKycIllustration({ className = "" }) {
  return (
    <svg viewBox="0 0 200 160" className={className} aria-hidden="true">
      <defs>
        <linearGradient id="bg" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0%" stopColor="#f4f2eb" />
          <stop offset="100%" stopColor="#ededE8" />
        </linearGradient>
      </defs>
      <rect x="0" y="0" width="200" height="160" rx="12" fill="url(#bg)" />
      {/* Document */}
      <rect x="50" y="34" width="80" height="100" rx="6" fill="#fff"
            stroke="#114232" strokeOpacity="0.18" />
      <rect x="60" y="50" width="50" height="4" rx="2" fill="#114232" opacity="0.6" />
      <rect x="60" y="62" width="38" height="3" rx="1.5" fill="#114232" opacity="0.18" />
      <rect x="60" y="72" width="55" height="3" rx="1.5" fill="#114232" opacity="0.18" />
      <rect x="60" y="82" width="46" height="3" rx="1.5" fill="#114232" opacity="0.18" />
      {/* Stamp / checkmark badge */}
      <circle cx="140" cy="100" r="22" fill="#114232" />
      <circle cx="140" cy="100" r="22" fill="#114232" />
      <path d="M130 100 l7 7 l13 -14" stroke="#f4f2eb" strokeWidth="3.5"
            fill="none" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="140" cy="100" r="26" fill="none" stroke="#d49a36" strokeWidth="1.5"
              strokeDasharray="3 3" opacity="0.55" />
      {/* Accent dots */}
      <circle cx="40" cy="30" r="3" fill="#c15337" opacity="0.75" />
      <circle cx="170" cy="40" r="2" fill="#d49a36" />
      <circle cx="32" cy="140" r="2.5" fill="#114232" opacity="0.4" />
    </svg>
  );
}

export function EmptyIncidentsIllustration({ className = "" }) {
  return (
    <svg viewBox="0 0 200 160" className={className} aria-hidden="true">
      <defs>
        <linearGradient id="bg2" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0%" stopColor="#f4f2eb" />
          <stop offset="100%" stopColor="#ededE8" />
        </linearGradient>
      </defs>
      <rect x="0" y="0" width="200" height="160" rx="12" fill="url(#bg2)" />
      {/* Heartbeat line */}
      <polyline
        points="20,90 50,90 60,90 70,60 85,120 100,55 115,90 150,90 180,90"
        fill="none" stroke="#114232" strokeWidth="2.4"
        strokeLinecap="round" strokeLinejoin="round"
      />
      {/* Shield over the spike */}
      <path
        d="M100 30 L80 38 L80 70 Q80 92 100 102 Q120 92 120 70 L120 38 Z"
        fill="#fff" stroke="#114232" strokeOpacity="0.25"
      />
      <path d="M93 70 l5 5 l11 -11" stroke="#114232" strokeWidth="3"
            fill="none" strokeLinecap="round" strokeLinejoin="round" />
      {/* Sand accent */}
      <circle cx="100" cy="55" r="3" fill="#c15337" />
      <circle cx="40" cy="40" r="2.5" fill="#d49a36" />
      <circle cx="170" cy="120" r="2" fill="#d49a36" />
      <rect x="50" y="135" width="100" height="3" rx="1.5" fill="#114232" opacity="0.1" />
    </svg>
  );
}

export function EmptyStateCard({ title, body, illustration, action, testid }) {
  return (
    <div
      className="bg-white rounded-lg border border-[#114232]/10 p-10 flex flex-col items-center text-center"
      data-testid={testid}
    >
      <div className="w-44 h-36">{illustration}</div>
      <h3 className="font-heading text-lg font-bold text-[#114232] mt-2">{title}</h3>
      {body && <p className="text-sm text-[#5c6360] max-w-sm mt-1">{body}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
